const identity = d => d;

export const compareFunctions = {
    ascValue: (a, b) => (a > b ? 1 : a === b ? 0 : -1),
    descValue: (a, b) => (a < b ? 1 : a === b ? 0 : -1)
};

const createSortComparator = (valueExtractor = identity, compareFunction = compareFunctions.ascValue) => {
    return (a, b) => compareFunction(valueExtractor(a), valueExtractor(b));
};

export default createSortComparator;

export const sortGamesByGameId = (isAsc, a, b) => (a?.gameId ?? 0) - (b?.gameId ?? 0) * (isAsc ? 1 : -1);
